<template>
  <div>
    <b-card :title="locals('leadcust.leadcust_search')">
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(0, 207, 232, 0.15)'"
              class="custom-add"
              :to="{ name: 'customer-form' }"
              pill
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{ $t("button.new") }}</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col cols="12" class="mb-2">
          <b-row>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.company_name')"
                label-for="i-company"
                class="title-freight"
              >
                <b-form-input
                  id="i-company"
                  v-model="dataFilter.strCustomerName"
                />
              </b-form-group>
            </b-col>
            <!-- <b-col md="3">
              <b-form-group
                label-for="i-addr"
                :label="locals('leadcust.addr')"
                class="title-freight"
              >
                <b-form-input id="i-addr" v-model="dataFilter.strAddress" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="ประเภทอุตสาหกรรมหลัก"
                label-for="i-main"
                class="title-freight"
              >
                <v-select
                  input-id="i-main"
                  v-model="dataFilter.intMainId"
                  :placeholder="locals('select.placeholder')"
                  label="strDsDesc"
                  :reduce="(val) => val.intDsId"
                  :options="MainOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Lead Stage"
                label-for="i-lead-stage"
                class="title-freight"
              >
                <v-select
                  input-id="i-lead-stage"
                  :clearable="true"
                  v-model="dataFilter.intLeadStageId"
                  :placeholder="locals('select.placeholder')"
                  label="strDsDesc"
                  :reduce="(val) => val.intDsId"
                  :options="leadstage"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row> -->
            <b-col md="3">
              <b-form-group
                label-for="i-tax"
                :label="locals('leadcust.taxnumber')"
                class="title-freight"
              >
                <b-form-input id="i-tax" v-model="dataFilter.strTaxId" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.status')"
                label-for="i-status"
                class="title-freight"
              >
                <v-select
                  id="i-status"
                  v-model="dataFilter.strStatus"
                  :placeholder="locals('select.placeholder')"
                  input-id="i-status"
                  label="title"
                  :reduce="(val) => val.title"
                  :options="status"
                />
              </b-form-group>
            </b-col>
            <!-- <b-col md="3">
              <b-form-group
                label-for="i-tier"
                label="Customer Tier"
                class="title-freight"
              >
                <b-form-input
                  id="i-tier"
                  v-model="dataFilter.strCustomerTier"
                  disabled
                />
              </b-form-group>
            </b-col>  
            <b-col md="3">
              <b-form-group
                label="ผู้ดูแล"
                label-for="i-by"
                class="title-freight"
              >
                <v-select
                  id="i-by"
                  v-model="dataFilter.strBy"
                  :placeholder="locals('select.placeholder')"
                  label="strDsDesc"
                  :options="UserOptions"
                />
              </b-form-group>
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            class="mr-1 custom-search btn-fixed-width"
            pill
            @click="onSearch"
          >
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.search") }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            class="mr-1 btn-fixed-width"
            pill
            @click="onClear"
          >
            <feather-icon icon="RefreshCwIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.clear") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary">
      <b-card title="รายละเอียด">
        <b-row class="pt-2">
          <b-col md="12">
            <vue-good-table
              :columns="columns"
              :rows="rows"
              :search-options="{
                enabled: false,
              }"
              :pagination-options="{
                enabled: true,
                perPage: pageLength,
              }"
              styleClass="vgt-table condensed"
            >
              <!-- Slot: Table Column -->
              <template slot="table-column" slot-scope="props">
                <span
                  v-if="props.column.label === 'Action'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.action") }}
                </span>
                <span
                  v-else-if="props.column.label === 'สถานะ'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.status") }}
                </span>
                <span
                  v-else-if="props.column.label === 'Inquiry Job no.'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.inquiry_job_no") }}
                </span>
                <span
                  v-else-if="props.column.label === 'ชื่อบริษัท'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.company_name") }}
                </span>
                <span
                  v-else-if="props.column.label === 'ด่วน'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.urgent") }}
                </span>
                <span
                  v-else-if="props.column.label === 'ผู้สร้าง'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.create_by") }}
                </span>
                <span
                  v-else-if="props.column.label === 'วันที่สร้าง'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.create_date") }}
                </span>
                <span
                  v-else-if="props.column.label === 'ผู้แก้ไข'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.update_by") }}
                </span>
                <span
                  v-else-if="props.column.label === 'วันที่แก้ไข'"
                  class="text-nowrap"
                >
                  {{ $t("inquiry.update_date") }}
                </span>
                <span v-else>
                  {{ props.column.label }}
                </span>
              </template>
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <div class="text-center">
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon rounded-circle mr-1"
                      v-b-tooltip.hover.v-warning
                      title="Edit"
                      @click="onEdit(props.index, props.row.intCustomerId)"
                    >
                      <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon rounded-circle"
                      v-b-tooltip.hover.v-danger
                      title="Delete"
                      @click="onDelete(props.index, props.row.intCustomerId)"
                    >
                      <font-awesome-icon icon="fa-solid fa-trash" />
                    </b-button>
                  </div>
                </span>
                <!-- Column: Status -->
                <span v-else-if="props.column.field === 'strStatus'">
                  <div class="text-center">
                    <b-badge :variant="statusVariant(props.row.strStatus)">
                      {{ props.row.strStatus }}
                    </b-badge>
                  </div>
                </span>
              </template>
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                      v-model="pageLength"
                      :options="['10', '20', '50', '100']"
                      class="mx-1"
                      @input="
                        (pageLength) =>
                          props.perPageChanged({
                            currentPerPage: pageLength,
                          })
                      "
                    />
                    <span class="text-nowrap">
                      of {{ props.total }} entries
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="
                        (pageLength) =>
                          props.pageChanged({
                            currentPage: pageLength,
                          })
                      "
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BPagination,
  BBadge,
  BFormSelect,
  BOverlay,
  VBTooltip,
  VBModal,
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

import Service from "@/@API/cDropdown";
import CustService from "@/@API/cCustomer";

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCard,
    BInputGroup,
    vSelect,
    BInputGroupAppend,
    BButton,
    flatPickr,
    VueGoodTable,
    BPagination,
    BBadge,
    BFormSelect,
    BOverlay,
    VBTooltip,
    VBModal,
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        Draft: "light-info",
        DRAFT: "light-info",
        Submit: "light-success",
        SUBMIT: "light-success",
        Canceled: "light-danger",
      };
      return (table_status) => statusColor[table_status];
    },
  },
  data() {
    return {
      isLoading: true,
      dataFilter: {
        intCustomerId: "",
        strCustomerName: "",
        intServiceId: "",
        strServiceDesc: "",
        intMainId: "",
        strMainDesc: "",
        intLeadStageId: "",
        strLeadStageDesc: "",
        strAddress: "",
        strStatus: "",
        strCustomerTier: "",
        strBy: "",
      },
      UserOptions: [
        {
          intDsId: 1,
          strDsDesc: "คุณดิว",
        },
        {
          intDsId: 2,
          strDsDesc: "คุณกุ๊ก",
        },
        {
          intDsId: 4,
          strDsDesc: "คุณโปเต้",
        },
        {
          intDsId: 5,
          strDsDesc: "คุณเจน",
        },
        {
          intDsId: 6,
          strDsDesc: "คุณจุ๊บแจง",
        },
        {
          intDsId: 7,
          strDsDesc: "คุณนภ",
        },
        {
          intDsId: 8,
          strDsDesc: "คุณดา",
        },
        {
          intDsId: 9,
          strDsDesc: "คุณน้อง",
        },
        {
          intDsId: 10,
          strDsDesc: "คุณปุ๋ม",
        },
        {
          intDsId: 99,
          strDsDesc: "-",
        },
      ],
      custOption: [{ strDsName: "Loading...", intDsId: 1 }],
      TestOptions: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      serviceOption: [
        {
          intDsId: 1,
          strDsDesc: "บริการ Freight",
        },
        {
          intDsId: 2,
          strDsDesc: "บริการ Custom Broker & Domestic transportation",
        },
        {
          intDsId: 3,
          strDsDesc: "บริการ RA",
        },
        {
          intDsId: 4,
          strDsDesc: "บริการ งานกฎหมาย Legal",
        },
      ],
      MainOptions: [
        {
          intDsId: 1,
          strDsDesc: "ผลิต",
        },
        {
          intDsId: 2,
          strDsDesc: "ขนส่ง",
        },
        {
          intDsId: 3,
          strDsDesc: "บริการ",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      leadstage: [
        { intDsId: 1, strDsDesc: "New" },
        { intDsId: 2, strDsDesc: "Work" },
        { intDsId: 3, strDsDesc: "Unqualified" },
        { intDsId: 4, strDsDesc: "Convert" },
      ],
      ori_status: [
        { title: "ร่าง", lang: "th_TH" },
        { title: "Draft", lang: "en_US" },
        { title: "บันทึก", lang: "th_TH" },
        { title: "Submit", lang: "en_US" },
        { title: "ยกเลิก", lang: "th_TH" },
        { title: "Canceled", lang: "en_US" },
      ],
      status: [],
      table_status: [
        {
          0: "Draft",
          1: "DRAFT",
          2: "Submit",
          3: "SUBMIT",
          4: "Canceled",
        },
        {
          0: "light-info",
          1: "light-info",
          2: "light-success",
          3: "light-success",
          4: "light-danger",
        },
      ],
      pageLength: 20,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "Action",
          field: "action",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานะ",
          field: "strStatus",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อบริษัท",
          field: "strCustomerName",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        // {
        //   label: "ประเภทอุตสาหกรรม",
        //   field: "strIndusMainDesc",
        //   width: "200px",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        // {
        //   label: "Lead Stage",
        //   field: "strLead",
        //   width: "200px",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        // {
        //   label: "Main Lead Owner",
        //   field: "mainleadowner",
        //   width: "200px",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        // {
        //   label: "Sale Name",
        //   field: "salename",
        //   width: "200px",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        {
          label: "ผู้สร้าง",
          field: "strCreatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่สร้าง",
          field: "datCreatedDate",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้แก้ไข",
          field: "strUpdatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่แก้ไข",
          field: "datUpdatedDate",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      rows: [],
    };
  },
  mounted() {
    localStorage.setItem("customer-id", -1);
    this.getDefault();
    this.onClear();
  },
  methods: {
    getDefault() {
      let lang = localStorage.getItem("language");
      let newstatus = [];
      newstatus = this.ori_status.filter((b) => b.lang == lang);
      this.status = newstatus;

      Service.getCustomerDropdown({})
        .then((response) => {
          this.custOption = [];
          response.data.lstCustomer.forEach((cc) => {
            this.custOption.push(cc);
          });
          console.log(response.data);
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSearch() {
      if (
        this.dataFilter.intCustomerId != "" &&
        this.dataFilter.intCustomerId != null
      ) {
        let currCust = this.custOption.find(
          (c) => c.intDsId === this.dataFilter.intCustomerId
        );
        this.dataFilter.strCustomerName = currCust.strDsName;
      }
      if (
        this.dataFilter.intServiceId != "" &&
        this.dataFilter.intServiceId != null
      ) {
        let currServ = this.custOption.find(
          (c) => c.intDsId === this.dataFilter.intServiceId
        );
        this.dataFilter.strServiceDesc = currServ.strDsName;
      }
      if (
        this.dataFilter.intMainId != "" &&
        this.dataFilter.intMainId != null
      ) {
        let currmain = this.custOption.find(
          (c) => c.intDsId === this.dataFilter.intMainId
        );
        this.dataFilter.strMainDesc = currmain.strDsName;
      }
      if (
        this.dataFilter.intLeadStageId != "" &&
        this.dataFilter.intLeadStageId != null
      ) {
        let currlead = this.custOption.find(
          (c) => c.intDsId === this.dataFilter.intLeadStageId
        );
        this.dataFilter.strLeadStageDesc = currlead.strDsName;
      }

      this.isLoading = true;
      CustService.getSearchCustomer(this.dataFilter)
        .then((response) => {
          console.log(response.data);
          this.isLoading = false;
          let lang = localStorage.getItem("lang");
          this.rows = response.data;
          this.rows.forEach((q) => {
            q.datCreatedDate = q.datCreatedDate
              ? moment(q.datCreatedDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datUpdatedDate = q.datUpdatedDate
              ? moment(q.datUpdatedDate).format("DD/MM/YYYY HH:mm")
              : null;
          });
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error", error);
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onEdit(index, Id) {
      this.$router.replace({ name: "customer-form" }).then(() => {
        localStorage.setItem("customer-id", Id);
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "แก้ไขเอกสาร",
              icon: "EditIcon",
              variant: "warning",
              text: "กำลังแก้ไขเอกสาร",
            },
          },
          {
            position: "top-center",
          }
        );
      });
    },
    onDelete(index, Id) {
      let lang = localStorage.getItem("language");

      let tttitle = "Confirm Delete";
      let msg = "Do you want to delete this customer?";
      let b1 = "Delete";
      let b2 = "Close";

      if (lang == "th_TH") {
        tttitle = "ยืนยันการลบ";
        msg = "คุณต้องการยืนยันลบเอกสารนี้ใช่หรือไม่ ?";
        b1 = "ลบ";
        b2 = "ปิด";
      }
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: tttitle,
          size: "sm",
          modalClass: "modal-danger",
          okVariant: "danger",
          okTitle: b1,
          cancelTitle: b2,
          cancelVariant: "outline-warning",
          hideHeaderClose: false,
          //centered: true,
        })
        .then((value) => {
          console.log(value);
          if (value) {
            CustService.getResponseDeleteCustomer({ intCustomerId: Id })
              .then((response) => {
                if (
                  response.data == "ไม่พบรายชื่อ" ||
                  response.data == "ไม่สามารถลบได้"
                ) {
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "Something was wrong",
                        icon: "FrownIcon",
                        variant: "danger",
                        text: response.data,
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                } else {
                  this.rows.splice(index, 1);
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "ลบข้อมูล",
                        icon: "XIcon",
                        variant: "success",
                        text: "ลบสำเร็จ",
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                }
              })
              .catch((error) => {
                console.log("error", error);
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "Something was wrong",
                      icon: "FrownIcon",
                      variant: "danger",
                      text: "Something was wrong : " + error,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
              });
          }
        });
    },
    onClear() {
      this.dataFilter = {
        intCustomerId: "",
        strCustomerName: "",
        intServiceId: "",
        strServiceDesc: "",
        intMainId: "",
        strMainDesc: "",
        intLeadStageId: "",
        strLeadStageDesc: "",
        strAddress: "",
        strStatus: "",
        strCustomerTier: "",
        strBy: "",
      };
      this.onSearch();
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
